import AppDataService from "./AppDataService";

export default class DocumentService {
  static async getDocumentList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${encodeURIComponent(data.name)}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`document${queryString}`);
  }

  static async createDocument(data) {
    return await AppDataService.post(`document`, data);
  }

  static async updateDocument(id, data) {
    return await AppDataService.patch(`document/${id}`, data);
  }

  static async deleteDocument(id) {
    return await AppDataService.delete(`document/${id}`);
  }
}
